import { useState } from "react";
import PageHeader from "components/PageHeader";
import { FeatureRequestStatus } from "../../../api/featureRequests";
import AddRequestModal from "./AddRequestModal";
import NewFeatureModal from "./NewFeatureModal";
import FeatureDetailModal from "./FeatureDetailModal";
import FeaturesTab from "./FeaturesTab";
import RequestsTab, {
  DEFAULT_REQUEST_FILTERS,
  RequestFilters,
} from "./RequestsTab";
import DSSegmentedTabs from "../../system-design/DSSegmentedTabs";
import DSBox from "../../system-design/DSBox";
import DSPrimaryButton from "../../system-design/DSPrimaryButton";
import DSSecondaryButton from "../../system-design/DSSecondaryButton";

type Tab = "requests" | "features";

const TAB_OPTIONS: { value: Tab; label: string }[] = [
  { value: "requests", label: "Requests" },
  { value: "features", label: "Features" },
];

const FeatureRequestsPage = () => {
  const [tab, setTab] = useState<Tab>("requests");
  // Kept here so the Features tab can open the Requests tab pre-filtered.
  const [requestFilters, setRequestFilters] = useState<RequestFilters>(
    DEFAULT_REQUEST_FILTERS,
  );
  const [selectedFeatureId, setSelectedFeatureId] = useState<string | null>(
    null,
  );
  const [addOpen, setAddOpen] = useState(false);
  const [newFeatureOpen, setNewFeatureOpen] = useState(false);

  const showRequests = (featureId: string, status: FeatureRequestStatus) => {
    setRequestFilters({ ...DEFAULT_REQUEST_FILTERS, featureId, status });
    setTab("requests");
  };

  return (
    <>
      <PageHeader
        overline="People"
        title="Feature Requests"
        subtitle="What customers asked for, grouped by feature. Mark a feature as deployed to flag its requests for review, then notify the customers."
        actions={
          <DSBox sx={{ display: "flex", gap: 1 }}>
            <DSSecondaryButton onClick={() => setNewFeatureOpen(true)}>
              New feature
            </DSSecondaryButton>
            <DSPrimaryButton onClick={() => setAddOpen(true)}>
              Add request
            </DSPrimaryButton>
          </DSBox>
        }
        tabs={
          <DSSegmentedTabs<Tab>
            options={TAB_OPTIONS}
            value={tab}
            onChange={(value) => value && setTab(value)}
          />
        }
      />

      {tab === "requests" ? (
        <RequestsTab
          filters={requestFilters}
          onFiltersChange={setRequestFilters}
        />
      ) : (
        <FeaturesTab
          onOpenFeature={setSelectedFeatureId}
          onShowRequests={showRequests}
        />
      )}

      <AddRequestModal open={addOpen} onClose={() => setAddOpen(false)} />
      <NewFeatureModal
        open={newFeatureOpen}
        onClose={() => setNewFeatureOpen(false)}
      />
      <FeatureDetailModal
        featureId={selectedFeatureId}
        onClose={() => setSelectedFeatureId(null)}
      />
    </>
  );
};

export default FeatureRequestsPage;
